import { defineMessages } from 'react-intl';

const messages = defineMessages({
  US: {
    description: 'country.name.US',
    defaultMessage: 'United States',
    id: 'NouqLQ',
  },
  AF: {
    description: 'country.name.AF',
    defaultMessage: 'Afghanistan ',
    id: '5SdeJk',
  },
  AL: {
    description: 'country.name.AL',
    defaultMessage: 'Albania',
    id: 'roHQdu',
  },
  DZ: {
    description: 'country.name.DZ',
    defaultMessage: 'Algeria',
    id: '2SmWPl',
  },
  AD: {
    description: 'country.name.AD',
    defaultMessage: 'Andorra',
    id: '5y8dD4',
  },
  AO: {
    description: 'country.name.AO',
    defaultMessage: 'Angola',
    id: 'CmibYH',
  },
  AI: {
    description: 'country.name.AI',
    defaultMessage: 'Anguilla',
    id: 'dZFBed',
  },
  AG: {
    description: 'country.name.AG',
    defaultMessage: 'Antigua & Barbuda',
    id: 'OKAfTc',
  },
  AR: {
    description: 'country.name.AR',
    defaultMessage: 'Argentina',
    id: '0xWyuV',
  },
  AM: {
    description: 'country.name.AM',
    defaultMessage: 'Armenia',
    id: 'xkPB8T',
  },
  AW: {
    description: 'country.name.AW',
    defaultMessage: 'Aruba',
    id: 'F/hQBv',
  },
  AU: {
    description: 'country.name.AU',
    defaultMessage: 'Australia',
    id: 'FlW+/A',
  },
  AT: {
    description: 'country.name.AT',
    defaultMessage: 'Austria',
    id: 'FiSUty',
  },
  AZ: {
    description: 'country.name.AZ',
    defaultMessage: 'Azerbaijan',
    id: 'Wex3ao',
  },
  BS: {
    description: 'country.name.BS',
    defaultMessage: 'Bahamas',
    id: 'PI0YHh',
  },
  BH: {
    description: 'country.name.BH',
    defaultMessage: 'Bahrain',
    id: 'a95oX3',
  },
  BD: {
    description: 'country.name.BD',
    defaultMessage: 'Bangladesh',
    id: 'tiXrE1',
  },
  BB: {
    description: 'country.name.BB',
    defaultMessage: 'Barbados',
    id: '+TeaCk',
  },
  BY: {
    description: 'country.name.BY',
    defaultMessage: 'Belarus',
    id: 'y5StEB',
  },
  BE: {
    description: 'country.name.BE',
    defaultMessage: 'Belgium',
    id: 'end0TX',
  },
  BZ: {
    description: 'country.name.BZ',
    defaultMessage: 'Belize',
    id: 'peVQgO',
  },
  BJ: {
    description: 'country.name.BJ',
    defaultMessage: 'Benin',
    id: 'bnHHRa',
  },
  BM: {
    description: 'country.name.BM',
    defaultMessage: 'Bermuda',
    id: 'ML/+Yw',
  },
  BT: {
    description: 'country.name.BT',
    defaultMessage: 'Bhutan',
    id: 't6Bn5H',
  },
  BO: {
    description: 'country.name.BO',
    defaultMessage: 'Bolivia',
    id: 'LzzMWx',
  },
  BA: {
    description: 'country.name.BA',
    defaultMessage: 'Bosnia-Herzegovina',
    id: 'zylmru',
  },
  BW: {
    description: 'country.name.BW',
    defaultMessage: 'Botswana',
    id: 'BRP/O4',
  },
  BR: {
    description: 'country.name.BR',
    defaultMessage: 'Brazil',
    id: 'mmgqnX',
  },
  VG: {
    description: 'country.name.VG',
    defaultMessage: 'British Virgin Islands',
    id: 'uYME+D',
  },
  BN: {
    description: 'country.name.BN',
    defaultMessage: 'Brunei Darussalam',
    id: 'tH0Wr5',
  },
  BG: {
    description: 'country.name.BG',
    defaultMessage: 'Bulgaria',
    id: 'gIXuER',
  },
  BF: {
    description: 'country.name.BF',
    defaultMessage: 'Burkina Faso',
    id: 'fAsJiN',
  },
  MM: {
    description: 'country.name.MM',
    defaultMessage: 'Burma (Myanmar)',
    id: 'qbnrkr',
  },
  BI: {
    description: 'country.name.BI',
    defaultMessage: 'Burundi ',
    id: 'LPovWo',
  },
  KH: {
    description: 'country.name.KH',
    defaultMessage: 'Cambodia',
    id: 'V8tAwJ',
  },
  CM: {
    description: 'country.name.CM',
    defaultMessage: 'Cameroon',
    id: 'e0XdLP',
  },
  CA: {
    description: 'country.name.CA',
    defaultMessage: 'Canada',
    id: 'wbKgfv',
  },
  CV: {
    description: 'country.name.CV',
    defaultMessage: 'Cape Verde',
    id: 'KWO3q9',
  },
  KY: {
    description: 'country.name.KY',
    defaultMessage: 'Cayman Islands',
    id: 'jmBZ4i',
  },
  CF: {
    description: 'country.name.CF',
    defaultMessage: 'Central African Republic',
    id: 'QqgBcu',
  },
  TD: {
    description: 'country.name.TD',
    defaultMessage: 'Chad',
    id: '65XRCg',
  },
  CL: {
    description: 'country.name.CL',
    defaultMessage: 'Chile',
    id: 'Inait5',
  },
  CN: {
    description: 'country.name.CN',
    defaultMessage: 'China',
    id: 'MBXe7F',
  },
  CO: {
    description: 'country.name.CO',
    defaultMessage: 'Colombia',
    id: 'uL63pP',
  },
  KM: {
    description: 'country.name.KM',
    defaultMessage: 'Comoros',
    id: 'a7oddR',
  },
  CD: {
    description: 'country.name.CD',
    defaultMessage: 'Congo, Democratic Republic of the',
    id: 'FZDkqa',
  },
  CG: {
    description: 'country.name.CG',
    defaultMessage: 'Congo, Republic of the',
    id: 'Ph7QDk',
  },
  CR: {
    description: 'country.name.CR',
    defaultMessage: 'Costa Rica',
    id: 'r/ksn4',
  },
  CI: {
    description: 'country.name.CI',
    defaultMessage: "Cote d'Ivoire (Ivory Coast)",
    id: 'rQTKXL',
  },
  HR: {
    description: 'country.name.HR',
    defaultMessage: 'Croatia',
    id: 'yhGhAV',
  },
  CY: {
    description: 'country.name.CY',
    defaultMessage: 'Cyprus',
    id: 'Z/7sK9',
  },
  CZ: {
    description: 'country.name.CZ',
    defaultMessage: 'Czech Republic',
    id: 'hhge7s',
  },
  DK: {
    description: 'country.name.DK',
    defaultMessage: 'Denmark',
    id: '+0C4aJ',
  },
  DJ: {
    description: 'country.name.DJ',
    defaultMessage: 'Djibouti',
    id: 'jCy9BG',
  },
  DM: {
    description: 'country.name.DM',
    defaultMessage: 'Dominica',
    id: '18sdx8',
  },
  DO: {
    description: 'country.name.DO',
    defaultMessage: 'Dominican Republic',
    id: 'ggOZkO',
  },
  EC: {
    description: 'country.name.EC',
    defaultMessage: 'Ecuador',
    id: 'yEhniV',
  },
  EG: {
    description: 'country.name.EG',
    defaultMessage: 'Egypt',
    id: '2PRRua',
  },
  SV: {
    description: 'country.name.SV',
    defaultMessage: 'El Salvador',
    id: 'GSodgL',
  },
  GQ: {
    description: 'country.name.GQ',
    defaultMessage: 'Equatorial Guinea',
    id: 'fRQKfS',
  },
  ER: {
    description: 'country.name.ER',
    defaultMessage: 'Eritrea',
    id: 'LT/wrh',
  },
  EE: {
    description: 'country.name.EE',
    defaultMessage: 'Estonia',
    id: 'kKRJOz',
  },
  ET: {
    description: 'country.name.ET',
    defaultMessage: 'Ethiopia',
    id: '98SHoY',
  },
  FO: {
    description: 'country.name.FO',
    defaultMessage: 'Faroe Islands',
    id: 'N/Gj4e',
  },
  FJ: {
    description: 'country.name.FJ',
    defaultMessage: 'Fiji',
    id: '2j16qF',
  },
  FI: {
    description: 'country.name.FI',
    defaultMessage: 'Finland',
    id: 'pa516H',
  },
  FR: {
    description: 'country.name.FR',
    defaultMessage: 'France',
    id: '1kA4m3',
  },
  GF: {
    description: 'country.name.GF',
    defaultMessage: 'French Guiana',
    id: 'O5WfSC',
  },
  PF: {
    description: 'country.name.PF',
    defaultMessage: 'French Polynesia',
    id: 'CLe4Vg',
  },
  GA: {
    description: 'country.name.GA',
    defaultMessage: 'Gabon',
    id: 'TpLOIJ',
  },
  GM: {
    description: 'country.name.GM',
    defaultMessage: 'Gambia',
    id: 'nibkz7',
  },
  GE: {
    description: 'country.name.GE',
    defaultMessage: 'Georgia, Republic of',
    id: 'bN1INf',
  },
  DE: {
    description: 'country.name.DE',
    defaultMessage: 'Germany',
    id: 'mSoljN',
  },
  GH: {
    description: 'country.name.GH',
    defaultMessage: 'Ghana',
    id: 'O+E6FP',
  },
  GI: {
    description: 'country.name.GI',
    defaultMessage: 'Gibraltar',
    id: 'ribV7P',
  },
  GB: {
    description: 'country.name.GB',
    defaultMessage: 'United Kingdom',
    id: 'gYRI2X',
  },
  GR: {
    description: 'country.name.GR',
    defaultMessage: 'Greece',
    id: 'IvE0QS',
  },
  GL: {
    description: 'country.name.GL',
    defaultMessage: 'Greenland',
    id: 'c2XTgr',
  },
  GD: {
    description: 'country.name.GD',
    defaultMessage: 'Grenada',
    id: 'IF5nml',
  },
  GP: {
    description: 'country.name.GP',
    defaultMessage: 'Guadeloupe',
    id: 'Q2ZhwM',
  },
  GT: {
    description: 'country.name.GT',
    defaultMessage: 'Guatemala',
    id: '4qDhyW',
  },
  GN: {
    description: 'country.name.GN',
    defaultMessage: 'Guinea',
    id: 'zjwU55',
  },
  GW: {
    description: 'country.name.GW',
    defaultMessage: 'Guinea-Bissau',
    id: 'cw1I1n',
  },
  GY: {
    description: 'country.name.GY',
    defaultMessage: 'Guyana',
    id: 'XHZ2j2',
  },
  HT: {
    description: 'country.name.HT',
    defaultMessage: 'Haiti',
    id: 'BLjPgK',
  },
  HN: {
    description: 'country.name.HN',
    defaultMessage: 'Honduras',
    id: 'nVWMqn',
  },
  HK: {
    description: 'country.name.HK',
    defaultMessage: 'Hong Kong',
    id: 'CzBohW',
  },
  HU: {
    description: 'country.name.HU',
    defaultMessage: 'Hungary',
    id: 'UQzrGF',
  },
  IS: {
    description: 'country.name.IS',
    defaultMessage: 'Iceland',
    id: 'nLX3N+',
  },
  IN: {
    description: 'country.name.IN',
    defaultMessage: 'India',
    id: 'EheOQF',
  },
  ID: {
    description: 'country.name.ID',
    defaultMessage: 'Indonesia',
    id: 'G6YvzK',
  },
  IR: {
    description: 'country.name.IR',
    defaultMessage: 'Iran',
    id: '44BwTQ',
  },
  IQ: {
    description: 'country.name.IQ',
    defaultMessage: 'Iraq',
    id: '1TDBNU',
  },
  IE: {
    description: 'country.name.IE',
    defaultMessage: 'Ireland (Eire)',
    id: 'St7Xgk',
  },
  IL: {
    description: 'country.name.IL',
    defaultMessage: 'Israel',
    id: 'ZiT+h3',
  },
  IT: {
    description: 'country.name.IT',
    defaultMessage: 'Italy',
    id: '3e8lEY',
  },
  JM: {
    description: 'country.name.JM',
    defaultMessage: 'Jamaica',
    id: 'Ex6ttk',
  },
  JP: {
    description: 'country.name.JP',
    defaultMessage: 'Japan',
    id: 'R11bPR',
  },
  JO: {
    description: 'country.name.JO',
    defaultMessage: 'Jordan',
    id: 'NUvABj',
  },
  KZ: {
    description: 'country.name.KZ',
    defaultMessage: 'Kazakhstan',
    id: 'HdMEAm',
  },
  KE: {
    description: 'country.name.KE',
    defaultMessage: 'Kenya',
    id: 'W0lNC0',
  },
  KI: {
    description: 'country.name.KI',
    defaultMessage: 'Kiribati',
    id: '5m6qZq',
  },
  KR: {
    description: 'country.name.KR',
    defaultMessage: 'Korea, Republic of (South)',
    id: 'NG4iqU',
  },
  KW: {
    description: 'country.name.KW',
    defaultMessage: 'Kuwait',
    id: 'jvQ089',
  },
  KG: {
    description: 'country.name.KG',
    defaultMessage: 'Kyrgyzstan',
    id: 'mzrWg+',
  },
  LA: {
    description: 'country.name.LA',
    defaultMessage: 'Laos',
    id: 'SxpZy/',
  },
  LV: {
    description: 'country.name.LV',
    defaultMessage: 'Latvia',
    id: 'L1Ynvu',
  },
  LB: {
    description: 'country.name.LB',
    defaultMessage: 'Lebanon ',
    id: 'SNGrXF',
  },
  LS: {
    description: 'country.name.LS',
    defaultMessage: 'Lesotho',
    id: 'bh4pBS',
  },
  LR: {
    description: 'country.name.LR',
    defaultMessage: 'Liberia ',
    id: 'b1+wng',
  },
  LY: {
    description: 'country.name.LY',
    defaultMessage: 'Libya',
    id: '0LGe8g',
  },
  LI: {
    description: 'country.name.LI',
    defaultMessage: 'Liechtenstein',
    id: 'VtbUKv',
  },
  LT: {
    description: 'country.name.LT',
    defaultMessage: 'Lithuania',
    id: 't6eLCn',
  },
  LU: {
    description: 'country.name.LU',
    defaultMessage: 'Luxembourg',
    id: 'RLcf1U',
  },
  MO: {
    description: 'country.name.MO',
    defaultMessage: 'Macao',
    id: 'eWZrbp',
  },
  MK: {
    description: 'country.name.MK',
    defaultMessage: 'Macedonia, Republic of',
    id: 'D/BKmJ',
  },
  MG: {
    description: 'country.name.MG',
    defaultMessage: 'Madagascar',
    id: 'tM+b88',
  },
  MW: {
    description: 'country.name.MW',
    defaultMessage: 'Malawi',
    id: 'Y/+Rpa',
  },
  MY: {
    description: 'country.name.MY',
    defaultMessage: 'Malaysia',
    id: 'tH4b0E',
  },
  MV: {
    description: 'country.name.MV',
    defaultMessage: 'Maldives',
    id: 'grJPlj',
  },
  ML: {
    description: 'country.name.ML',
    defaultMessage: 'Mali',
    id: 'uwnz/k',
  },
  MT: {
    description: 'country.name.MT',
    defaultMessage: 'Malta',
    id: 'MJBfCk',
  },
  MQ: {
    description: 'country.name.MQ',
    defaultMessage: 'Martinique',
    id: 'EN193T',
  },
  MR: {
    description: 'country.name.MR',
    defaultMessage: 'Mauritania',
    id: 'Jn362Z',
  },
  MU: {
    description: 'country.name.MU',
    defaultMessage: 'Mauritius',
    id: 'pTh88z',
  },
  MX: {
    description: 'country.name.MX',
    defaultMessage: 'Mexico',
    id: 'Q2mOEO',
  },
  MD: {
    description: 'country.name.MD',
    defaultMessage: 'Moldova',
    id: 'nSrMlA',
  },
  MN: {
    description: 'country.name.MN',
    defaultMessage: 'Mongolia',
    id: 'LAmeLD',
  },
  ME: {
    description: 'country.name.ME',
    defaultMessage: 'Montenegro',
    id: 'x1LPXw',
  },
  MS: {
    description: 'country.name.MS',
    defaultMessage: 'Montserrat',
    id: 'N0re7t',
  },
  MA: {
    description: 'country.name.MA',
    defaultMessage: 'Morocco',
    id: 'DPEiaw',
  },
  MZ: {
    description: 'country.name.MZ',
    defaultMessage: 'Mozambique',
    id: 'HEsp9D',
  },
  NA: {
    description: 'country.name.NA',
    defaultMessage: 'Namibia',
    id: 'npg2Pa',
  },
  NR: {
    description: 'country.name.NR',
    defaultMessage: 'Nauru',
    id: '4gwmky',
  },
  NP: {
    description: 'country.name.NP',
    defaultMessage: 'Nepal',
    id: '1h4hv6',
  },
  NL: {
    description: 'country.name.NL',
    defaultMessage: 'Netherlands',
    id: '9AjFnq',
  },
  NC: {
    description: 'country.name.NC',
    defaultMessage: 'New Caledonia',
    id: '0KrVqJ',
  },
  NZ: {
    description: 'country.name.NZ',
    defaultMessage: 'New Zealand',
    id: 'bHWkfY',
  },
  NI: {
    description: 'country.name.NI',
    defaultMessage: 'Nicaragua',
    id: 'V2TBVa',
  },
  NE: {
    description: 'country.name.NE',
    defaultMessage: 'Niger',
    id: 'h/MJ2z',
  },
  NG: {
    description: 'country.name.NG',
    defaultMessage: 'Nigeria',
    id: 'rA+L29',
  },
  NO: {
    description: 'country.name.NO',
    defaultMessage: 'Norway',
    id: 'KT9xLy',
  },
  OM: {
    description: 'country.name.OM',
    defaultMessage: 'Oman',
    id: 'F4/tTJ',
  },
  PK: {
    description: 'country.name.PK',
    defaultMessage: 'Pakistan',
    id: 'pw3/4Y',
  },
  PA: {
    description: 'country.name.PA',
    defaultMessage: 'Panama',
    id: 'RDD4mq',
  },
  PG: {
    description: 'country.name.PG',
    defaultMessage: 'Papua New Guinea',
    id: 'o2XWPY',
  },
  PY: {
    description: 'country.name.PY',
    defaultMessage: 'Paraguay',
    id: 'InBQHu',
  },
  PE: {
    description: 'country.name.PE',
    defaultMessage: 'Peru',
    id: 'jDIf/W',
  },
  PH: {
    description: 'country.name.PH',
    defaultMessage: 'Philippines',
    id: 'F0Hp2p',
  },
  PN: {
    description: 'country.name.PN',
    defaultMessage: 'Pitcairn Island',
    id: '94kEXo',
  },
  PL: {
    description: 'country.name.PL',
    defaultMessage: 'Poland',
    id: 'w3+Nau',
  },
  PT: {
    description: 'country.name.PT',
    defaultMessage: 'Portugal',
    id: 'G8td2q',
  },
  QA: {
    description: 'country.name.QA',
    defaultMessage: 'Qatar',
    id: '51HBVd',
  },
  RE: {
    description: 'country.name.RE',
    defaultMessage: 'Reunion',
    id: 'AX8k3L',
  },
  RO: {
    description: 'country.name.RO',
    defaultMessage: 'Romania',
    id: 'XyGJCw',
  },
  RU: {
    description: 'country.name.RU',
    defaultMessage: 'Russia',
    id: 'VOEDaz',
  },
  RW: {
    description: 'country.name.RW',
    defaultMessage: 'Rwanda',
    id: '4ZFNxd',
  },
  KN: {
    description: 'country.name.KN',
    defaultMessage: 'St. Christopher (St. Kitts) & Nevis',
    id: 'Rds4I3',
  },
  SH: {
    description: 'country.name.SH',
    defaultMessage: 'Saint Helena',
    id: 'qveHcC',
  },
  LC: {
    description: 'country.name.LC',
    defaultMessage: 'Saint Lucia',
    id: 'VwfP5F',
  },
  PM: {
    description: 'country.name.PM',
    defaultMessage: 'Saint Pierre & Miquelon',
    id: '4mddE+',
  },
  VC: {
    description: 'country.name.VC',
    defaultMessage: 'Saint Vincent & Grenadines',
    id: 'yPJ7iE',
  },
  SM: {
    description: 'country.name.SM',
    defaultMessage: 'San Marino',
    id: 'JtjAej',
  },
  ST: {
    description: 'country.name.ST',
    defaultMessage: 'Sao Tome & Principe',
    id: 'V+PMxj',
  },
  SA: {
    description: 'country.name.SA',
    defaultMessage: 'Saudi Arabia',
    id: 'brPfBZ',
  },
  SN: {
    description: 'country.name.SN',
    defaultMessage: 'Senegal',
    id: 'dYUIMl',
  },
  RS: {
    description: 'country.name.RS',
    defaultMessage: 'Serbia',
    id: 'DLiGyV',
  },
  SC: {
    description: 'country.name.SC',
    defaultMessage: 'Seychelles',
    id: 'xZ4S/w',
  },
  SL: {
    description: 'country.name.SL',
    defaultMessage: 'Sierra Leone ',
    id: 'KsX4HC',
  },
  SG: {
    description: 'country.name.SG',
    defaultMessage: 'Singapore',
    id: 'FoUxpv',
  },
  SK: {
    description: 'country.name.SK',
    defaultMessage: 'Slovak Republic (Slovakia)',
    id: 'fw+3jj',
  },
  SI: {
    description: 'country.name.SI',
    defaultMessage: 'Slovenia',
    id: 'ceysW0',
  },
  SB: {
    description: 'country.name.SB',
    defaultMessage: 'Solomon Islands',
    id: '9Y+VG2',
  },
  ZA: {
    description: 'country.name.ZA',
    defaultMessage: 'South Africa',
    id: 'wvf+IV',
  },
  ES: {
    description: 'country.name.ES',
    defaultMessage: 'Spain',
    id: 'gYi1VU',
  },
  LK: {
    description: 'country.name.LK',
    defaultMessage: 'Sri Lanka',
    id: 'rQVzWn',
  },
  SD: {
    description: 'country.name.SD',
    defaultMessage: 'Sudan',
    id: 'M9JVkG',
  },
  SR: {
    description: 'country.name.SR',
    defaultMessage: 'Suriname',
    id: 'MGVVYC',
  },
  SZ: {
    description: 'country.name.SZ',
    defaultMessage: 'Swaziland',
    id: 'jJ4HwA',
  },
  SE: {
    description: 'country.name.SE',
    defaultMessage: 'Sweden',
    id: 'I2B/i6',
  },
  CH: {
    description: 'country.name.CH',
    defaultMessage: 'Switzerland',
    id: 'sTNoMc',
  },
  SY: {
    description: 'country.name.SY',
    defaultMessage: 'Syrian Arab Republic (Syria)',
    id: 'yJCmvg',
  },
  TW: {
    description: 'country.name.TW',
    defaultMessage: 'Taiwan',
    id: 'SHAHpP',
  },
  TJ: {
    description: 'country.name.TJ',
    defaultMessage: 'Tajikistan',
    id: 'Nl5XTZ',
  },
  TZ: {
    description: 'country.name.TZ',
    defaultMessage: 'Tanzania',
    id: 'BtW8BN',
  },
  TH: {
    description: 'country.name.TH',
    defaultMessage: 'Thailand',
    id: 'iMTUs/',
  },
  TG: {
    description: 'country.name.TG',
    defaultMessage: 'Togo',
    id: 'ExxuBk',
  },
  TO: {
    description: 'country.name.TO',
    defaultMessage: 'Tonga',
    id: 'HVzPWD',
  },
  TT: {
    description: 'country.name.TT',
    defaultMessage: 'Trinidad & Tobago',
    id: 'RkXRlS',
  },
  TA: {
    description: 'country.name.TA',
    defaultMessage: 'Tristan da Cunha',
    id: 'NIE3Y9',
  },
  TN: {
    description: 'country.name.TN',
    defaultMessage: 'Tunisia',
    id: '030hty',
  },
  TR: {
    description: 'country.name.TR',
    defaultMessage: 'Turkey',
    id: 'EEdJ6f',
  },
  TM: {
    description: 'country.name.TM',
    defaultMessage: 'Turkmenistan',
    id: 'GYBkXU',
  },
  TC: {
    description: 'country.name.TC',
    defaultMessage: 'Turks & Caicos Islands',
    id: 'LYV9Eh',
  },
  TV: {
    description: 'country.name.TV',
    defaultMessage: 'Tuvalu',
    id: 'suk2b6',
  },
  UG: {
    description: 'country.name.UG',
    defaultMessage: 'Uganda',
    id: 'bDbvz9',
  },
  UA: {
    description: 'country.name.UA',
    defaultMessage: 'Ukraine',
    id: 'OD4XGV',
  },
  AE: {
    description: 'country.name.AE',
    defaultMessage: 'United Arab Emirates',
    id: 'q+Jnbw',
  },
  UY: {
    description: 'country.name.UY',
    defaultMessage: 'Uruguay',
    id: 'L9SF2R',
  },
  UZ: {
    description: 'country.name.UZ',
    defaultMessage: 'Uzbekistan',
    id: 'Eek8Fu',
  },
  VU: {
    description: 'country.name.VU',
    defaultMessage: 'Vanuatu',
    id: 's+7izk',
  },
  VA: {
    description: 'country.name.VA',
    defaultMessage: 'Vatican City',
    id: 'rl4F/Y',
  },
  VE: {
    description: 'country.name.VE',
    defaultMessage: 'Venezuela',
    id: 'PUI2F5',
  },
  VN: {
    description: 'country.name.VN',
    defaultMessage: 'Vietnam',
    id: 'QL5IKi',
  },
  WF: {
    description: 'country.name.WF',
    defaultMessage: 'Wallis & Futuna Islands',
    id: 'krV9lI',
  },
  WS: {
    description: 'country.name.WS',
    defaultMessage: 'Western Samoa',
    id: 'uRKaGw',
  },
  YE: {
    description: 'country.name.YE',
    defaultMessage: 'Yemen',
    id: 'fXUDKD',
  },
  ZM: {
    description: 'country.name.ZM',
    defaultMessage: 'Zambia',
    id: 'qIPmeK',
  },
  ZW: {
    description: 'country.name.ZW',
    defaultMessage: 'Zimbabwe',
    id: 'gxrbnN',
  },
  XK: {
    description: 'country.name.XK',
    defaultMessage: 'Kosovo, Republic Of',
    id: '+5DC5t',
  },
  GG: {
    description: 'country.name.GG',
    defaultMessage: 'Guernsey',
    id: 'gmOXS5',
  },
  JE: {
    description: 'country.name.JE',
    defaultMessage: 'Jersey',
    id: 'gVnrOY',
  },
  PR: {
    description: 'country.name.PR',
    defaultMessage: 'Puerto Rico',
    id: 'GMGXkj',
  },
  VI: {
    description: 'country.name.VI',
    defaultMessage: 'US Virgin Islands',
    id: 'jUD+AZ',
  },
  GU: {
    description: 'country.name.GU',
    defaultMessage: 'Guam',
    id: '5T8bP6',
  },
  CK: {
    description: 'country.name.CK',
    defaultMessage: 'Cook Islands',
    id: 'qzp7Y9',
  },
  PW: {
    description: 'country.name.PW',
    defaultMessage: 'Palau',
    id: 'ZqrfHc',
  },
  MC: {
    description: 'country.name.MC',
    defaultMessage: 'Monaco',
    id: 'ZMftwj',
  },
  FM: {
    description: 'country.name.FM',
    defaultMessage: 'Micronesia',
    id: 'GV2488',
  },
  MH: {
    description: 'country.name.MH',
    defaultMessage: 'Marshall Islands',
    id: 'q6IRyQ',
  },
  AS: {
    description: 'country.name.AS',
    defaultMessage: 'American Samoa',
    id: 's43Wvh',
  },
  MP: {
    description: 'country.name.MP',
    defaultMessage: 'Northern Mariana Islands',
    id: 'n5YZuC',
  },
  CW: {
    description: 'country.name.CW',
    defaultMessage: 'Curacao',
    id: 'Hklz8J',
  },
  SX: {
    description: 'country.name.SX',
    defaultMessage: 'Sint Maarten',
    id: 'whAbAy',
  },
  BL: {
    description: 'country.name.BL',
    defaultMessage: 'Saint Barthelemy (St. Barth)',
    id: 'VLH2K/',
  },
  IC: {
    description: 'country.name.IC',
    defaultMessage: 'Canary Islands',
    id: 'aNLPVm',
  },
  FK: {
    description: 'country.name.FK',
    defaultMessage: 'Falkland Islands',
    id: 'rwrutg',
  },
  TL: {
    description: 'country.name.TL',
    defaultMessage: 'Timor Leste',
    id: 'UbXjXe',
  },
  BQ: {
    description: 'country.name.BQ',
    defaultMessage: 'Bonaire, Sint Eustatius and Saba',
    id: 'bdQjRC',
  },
  NF: {
    description: 'country.name.NF',
    defaultMessage: 'Norfolk Island',
    id: 'k/EdLc',
  },
  SJ: {
    description: 'country.name.SJ',
    defaultMessage: 'Svalbard and Jan Mayen',
    id: 's0BDCK',
  },
});

export default messages;
